import { api } from '../api'
import type { DrillSequenceCreate, Drill, DrillCreate } from '@acepoker/contract'

export const createDrill = async (drillTemplate: {
  drill: DrillCreate
  sequence?: DrillSequenceCreate
}): Promise<{ id: Drill['id'] }> => await api().url('/api/drill').post(drillTemplate).json()
